import { openModal } from '@core/components/ModalStack';
import { DownloadFolderModalProps } from './DownloadFolderModal';

export async function openDownloadFolderModal(props: DownloadFolderModalProps) {
  const { DownloadFolderModal } = await import('./DownloadFolderModal');

  openModal(DownloadFolderModal, props);
}

export * from './OrgFiles';
